<template>
  <div class="lv-event-card">
    <LvText
      v-if="_cardType"
      :bold="bold"
      :h6="!titleSize"
      :lightGray="!bold"
      :style="{ fontSize: titleSize + 'rem' }"
      >{{ _cardType }}</LvText
    >
    <div class="lv-event-card__content-wrap" @click="$_onClick()">
      <WsLoading primary v-if="isLoading" />
      <div v-else>
        <i class="leading-icon" :class="[alertColor, _leadingIcon]" />
        <div class="lv-event-card__content">
          <LvText h5 bold>{{ _title }}</LvText>
          <div class="lv-event-card__content-list">
            <div class="lv-event-card__list-item">
              <LvText v-if="_date" remark lightGray class="lv-event-card__text">{{
                _dateLabel
              }}</LvText>
              <LvText v-if="_date" remark class="lv-event-card__text">{{ _date }}</LvText>
            </div>
            <div v-if="_condition && type === 'task'" class="lv-event-card__list-item">
              <LvText v-if="_date" remark lightGray class="lv-event-card__text">{{
                $t('任務狀態')
              }}</LvText>
              <div class="lv-event-card__chip">
                <ContentChip
                  narrow
                  :textLabel="_condition"
                  :yellow="_conditionColor === 'yellow'"
                  :lightGray="_conditionColor === 'lightGray'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LvPopupInfoArticle ref="LvPopupInfoArticle" />
  </div>
</template>
<script>
import S_task from '@/service/api/v1/task';
import S_alert from '@/service/api/v1/alert';
import S_event from '@/service/api/v1/event';
import S_change from '@/service/api/v1/change';
import S_article from '@/service/api/v1/article';
import S_actVersion from '@/service/api/v1/actVersion';
import S_llBroadcast from '@/service/api/v1/ll_broadcast';
import S_auditRecord from '@/service/api/v1/audit_record';
import S_checklistRecord from '@/service/api/v1/checklist_record';
import S_internalTraining from '@/service/api/v1/internal_training';
// import S_guidelineVersionAdmin from '@/service/api/v1/guidelineVersionAdmin';
// import S_guidelineArticleVersionAdmin from '@/service/api/v1/guidelineArticleVersionAdmin';
import H_alert from '@/helpers/alert';

export default {
  props: {
    leadingIcon: {
      type: String,
    },
    date: {
      type: String,
    },
    alert: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    dateLabel: {
      type: String,
    },
    titleSize: {
      type: Number,
      default: 0.875,
    },
    type: {
      type: String,
    },
    id: {
      type: [Number, String],
      default: 0,
    },
    from: {
      type: String,
    },
    alertId: {
      type: String,
    },
    versionId: {
      type: String,
    },
    customQuery: {
      type: Function,
    },
    name: {
      type: String,
    },
    customClickEvent: {
      type: Function,
    },
  },
  data: () => ({
    article: null,
    articleVersion: null,
    event: null,
    task: null,
    change: null,
    broadcast: null,
    alertColor: '',
    alertData: null,
    auditRecord: null,
    checklistRecord: null,
    isLoading: false,
    internalTrainingGroup: null,
    actVersion: null,
    guidelineVersion: null,
    guidelineArticleVersion: null,
  }),
  computed: {
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
    _condition() {
      if (!this.task) return '';
      if (!this.task.done_at && !this.task.checked_at) {
        return this.$t('進行中');
      } else if (this.task.done_at && !this.task.checked_at) {
        return this.$t('待審核');
      } else {
        return this.$t('已完成');
      }
    },
    _conditionColor() {
      if (!this.task) return '';
      if (!this.task.done_at && !this.task.checked_at) {
        return 'yellow';
      } else if (this.task.done_at && !this.task.checked_at) {
        return 'yellow';
      } else {
        return 'lightGray';
      }
    },
    _title() {
      if (this.name) return this.name;
      if (this.type === 'task') {
        return this.task ? this.task.name : '';
      } else if (this.type === 'alert') {
        if (!this.alertData) {
          return this.$t('相關警示');
        } else {
          return H_alert.getAlertDataName(this.alertData);
        }
      } else if (this.type === 'event') {
        if (!this.event) return;
        const eventName = this.event.name;
        return `${eventName}`;
      } else if (this.type === 'article') {
        if (!this.article) return;
        const actName = this.article.act_version.name;
        const articleNumber = this.article.last_version.no_text;
        return `${actName}  ${articleNumber}`;
      } else if (this.type === 'article_version') {
        if (!this.articleVersion) return;
        const actName = this.articleVersion.act_versions[0].name;
        const articleNumber = this.articleVersion.no_text;
        return `${actName}  ${articleNumber}`;
      } else if (this.type === 'change') {
        if (!this.change) return '';
        const changeName = this.change.name;
        return `[${this.$t('變動計畫')}]${changeName}`;
      } else if (this.type === 'broadcast') {
        if (!this.broadcast) return;
        return this.broadcast.name;
      } else if (this.type === 'auditRecord') {
        if (!this.auditRecord) return;
        return this.auditRecord.name;
      } else if (this.type === 'checklistRecord') {
        if (!this.checklistRecord) return;
        return this.checklistRecord.name;
      } else if (this.type === 'internalTrainingGroup') {
        if (!this.internalTrainingGroup) return;
        return this.internalTrainingGroup.name;
      } else if (this.type === 'actVersion') {
        if (!this.actVersion) return;
        return this.actVersion.name;
      } else if (this.type === 'guidelineVersion') {
        if (!this.guidelineVersion) return;
        return this.guidelineVersion.name;
      } else if (this.type === 'guidelineArticleVersion') {
        if (!this.guidelineArticleVersion) return;
        return this.guidelineArticleVersion.name;
      } else {
        return this.$t('相關');
      }
    },
    _dateLabel() {
      if (this.type === 'task') {
        return this.$t('建立日期');
      } else if (this.type === 'alert') {
        return this.$t('警示發布');
      } else if (this.type === 'event') {
        return this.$t('事件發生');
      } else if (this.type === 'article') {
        return this.$t('法條發佈');
      } else if (this.type === 'article_version') {
        return this.$t('法條發佈');
      } else if (this.type === 'broadcast') {
        return this.$t('發布日期');
      } else if (this.type === 'change' || this.type === 'internalTrainingGroup') {
        return this.$t('建立日期');
      } else if (this.type === 'auditRecord') {
        return this.$t('稽核時間');
      } else if (this.type === 'checklistRecord') {
        return this.$t('點檢時間');
      } else if (this.type === 'actVersion') {
        return this.$t('法規發布');
      } else if (this.type === 'guidelineVersion' || this.type === 'guidelineArticleVersion') {
        return this.$t('修正發布日');
      } else {
        return this.$t('時間');
      }
    },
    _cardType() {
      if (this.type === 'task') {
        return this.$t('相關任務');
      } else if (this.type === 'alert') {
        return this.$t('相關警示');
      } else if (this.type === 'event') {
        return this.$t('相關事件');
      } else if (this.type === 'article') {
        return this.$t('相關法條');
      } else if (this.type === 'article_version') {
        return this.$t('相關法條');
      } else if (this.type === 'broadcast') {
        return this.$t('ESGoal快報');
      } else if (this.type === 'change') {
        return this.$t('相關變動計畫');
      } else if (this.type === 'auditRecord') {
        return this.$t('相關稽核記錄');
      } else if (this.type === 'checklistRecord') {
        return this.$t('相關點檢記錄');
      } else if (this.type === 'internalTrainingGroup') {
        return this.$t('相關教育訓練群組');
      } else if (this.type === 'actVersion') {
        return this.$t('相關法規');
      } else if (this.type === 'guidelineVersion') {
        return this.$t('相關內規');
      } else if (this.type === 'guidelineArticleVersion') {
        return this.$t('相關內規層級條文');
      } else {
        return this.$t('相關');
      }
    },
    _leadingIcon() {
      if (this.type === 'task') {
        return 'icon-nav-assignment-filled';
      } else if (this.type === 'alert') {
        return 'icon-alert-filled';
      } else if (this.type === 'event') {
        return 'icon-nav-event-filled';
      } else if (this.type === 'article' || this.type === 'actVersion') {
        return 'icon-nav-assignment-filled';
      } else if (this.type === 'article_version') {
        return 'icon-nav-assignment-filled';
      } else if (this.type === 'broadcast' || this.type === 'internalTrainingGroup') {
        return 'icon-nav-assignment-filled';
      } else if (this.type === 'auditRecord') {
        return 'icon-nav-audit-filled';
      } else if (this.type === 'checklistRecord') {
        return 'icon-nav-checksheet-filled';
      } else {
        return '';
      }
    },
    _date() {
      if (this.date) return this.date;
      let date = '';
      if (this.article) {
        date = this.$_dateFormat(this.article.updated_at);
      } else if (this.articleVersion) {
        date = this.$_dateFormat(this.articleVersion.updated_at);
      } else if (this.event) {
        date = this.$_dateTimeFormat(this.event.occur_at);
      } else if (this.alertData) {
        date = this.$_dateFormat(this.alertData.created_at);
      } else if (this.task) {
        date = this.$_dateFormat(this.task.created_at);
      } else if (this.broadcast) {
        date = this.$_dateTimeSecFormat(this.broadcast.created_at);
      } else if (this.change) {
        date = this.$_dateFormat(this.change.created_at);
      } else if (this.auditRecord) {
        date = this.$_dateFormat(this.auditRecord.record_at);
      } else if (this.checklistRecord) {
        date = this.$_dateFormat(this.checklistRecord.record_at);
      } else if (this.internalTrainingGroup) {
        date = this.$_dateFormat(this.internalTrainingGroup.created_at);
      } else if (this.actVersion) {
        date = this.$_dateFormat(this.actVersion.updated_at);
      } else if (this.guidelineVersion) {
        date = this.$_dateFormat(this.guidelineVersion.announce_at);
      } else if (this.guidelineArticleVersion) {
        date = this.$_dateFormat(this.guidelineArticleVersion.announce_at);
      }
      return date;
    },
  },
  async mounted() {
    this.isLoading = true;
    switch (this.type) {
      case 'task':
        await this.$_getTaskContent();
        break;
      case 'alert':
        await this.$_getAlertContent();
        break;
      case 'event':
        await this.$_getEventContent();
        break;
      case 'change':
        await this.$_getChangeContent();
        break;
      case 'article':
        await this.$_getArticleContent();
        break;
      case 'broadcast':
        await this.$_getBroadcastContent();
        break;
      case 'auditRecord':
        await this.$_getAuditRecordContent();
        break;
      case 'article_version':
        await this.$_getArticleVersionContent();
        break;
      case 'checklistRecord':
        await this.$_getChecklistRecordContent();
        break;
      case 'internalTrainingGroup':
        await this.$_getInternalTrainingGroup();
        break;
      case 'actVersion':
        await this.$_getActVersion();
        break;
      // case 'guidelineVersion': await this.$_getGuidelineVersion(); break;
      // case 'guidelineArticleVersion': await this.$_getGuidelineArticleVersion(); break;
    }
    this.isLoading = false;
  },
  methods: {
    $_dateFormat(date) {
      if (!date) return;
      return this.$moment(date).format('YYYY-MM-DD');
    },
    $_dateTimeFormat(date) {
      if (!date) return;
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    $_dateTimeSecFormat(date) {
      if (!date) return;
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    $_onClick() {
      if (this.customClickEvent) {
        this.customClickEvent(this, this.from, this.$route.fullPath, this._currentFactoryId);
        return;
      }
      let path = `/factory/${this._currentFactoryId}/`;
      let query = {
        from: this.from,
        redirect: `${this.$route.fullPath}`,
      };
      switch (this.type) {
        case 'task': {
          path += `task-content/${this.task.id}`;
          query = {
            ...query,
            alert: this.alertId,
          };
          break;
        }
        case 'alert': {
          path += `alert-content/${this.alertData.id}`;
          break;
        }
        case 'event': {
          path += `event-content/${this.event.id}`;
          break;
        }
        case 'article': {
          path += `act-content-main/${this.article.act_version.act_id}`;
          query = {
            ...query,
            article: this.article.last_version.id,
          };
          break;
        }
        case 'article_version': {
          path += `act-content-main/${this.articleVersion.act_versions[0].act.id}`;
          query = {
            ...query,
            article: this.articleVersion.id,
          };
          break;
        }
        case 'change': {
          path += `change-content/${this.change.id}`;
          break;
        }
        case 'broadcast': {
          path += `broadcast-content/${this.broadcast.id}`;
          break;
        }
        case 'auditRecord': {
          path += `auditer-result/${this.auditRecord.id}`;
          break;
        }
        case 'checklistRecord': {
          path += `checklist-result-view/${this.checklistRecord.id}`;
          break;
        }
        case 'internalTrainingGroup': {
          path += `internal-training-group-content/${this.internalTrainingGroup.id}`;
          break;
        }
        case 'actVersion': {
          path += `act-content-main/${this.id}`;
          query = {
            ...query,
            versionId: this.versionId,
          };
          break;
        }
        case 'guidelineVersion': {
          path += `guideline-content/${this.id}`;
          query = {
            ...query,
            versionId: this.versionId,
          };
          break;
        }
        case 'guidelineArticleVersion': {
          path += `guideline-content/${this.id}`;
          query = {
            ...query,
            versionId: this.versionId,
          };
          break;
        }
      }
      if (this.customQuery) query = this.customQuery(query);
      const route = this.$router.resolve({ path, query });
      this.$router.push(route.href);
    },
    async $_getArticleContent() {
      const articleContent = await S_article.articleShow(this._currentFactoryId, this.id);
      this.article = articleContent;
    },
    async $_getArticleVersionContent() {
      const articleContent = await S_article.articleVersionShow(this._currentFactoryId, this.id);
      this.articleVersion = articleContent;
    },
    async $_getChangeContent() {
      const changeContent = await S_change.getChangeContent(this.id);
      this.change = changeContent;
    },
    async $_getBroadcastContent() {
      const broadcastContent = await S_llBroadcast.show(this.id);
      this.broadcast = broadcastContent;
    },
    async $_getAuditRecordContent() {
      const auditRecordContent = await S_auditRecord.show(this.id);
      this.auditRecord = auditRecordContent;
    },
    async $_getChecklistRecordContent() {
      const checklistRecordContent = await S_checklistRecord.show(this.id);
      this.checklistRecord = checklistRecordContent;
    },
    async $_getEventContent() {
      const eventContent = await S_event.show(this.id);
      this.event = eventContent;
    },
    async $_getTaskContent() {
      const taskContent = await S_task.show(this.id);
      this.task = taskContent;
    },
    async $_getAlertContent() {
      const alertContent = await S_alert.show(this.id);
      this.alertData = alertContent;
      if (this.alertData.level === 2) {
        this.alertColor = 'level2';
      }
      if (this.alertData.level === 1) {
        this.alertColor = 'level1';
      }
    },
    async $_getInternalTrainingGroup() {
      const res = await S_internalTraining.showGroup(this.id);
      this.internalTrainingGroup = res;
    },
    async $_getActVersion() {
      this.actVersion = await S_actVersion.show(this.versionId);
    },
    // async $_getGuidelineVersion() {
    //   this.guidelineVersion = await S_guidelineVersionAdmin.show(this.versionId);
    // },
    // async $_getGuidelineArticleVersion() {
    //   this.guidelineArticleVersion = await S_guidelineArticleVersionAdmin.show(this.versionId);
    // },
  },
  getRecordResult(level) {
    return H_alert.getRecordResult(level);
  },
};
</script>
